export const TEXTS = {
  FLX_REWARDS_HEADING: 'FLX Rewards',
  MEMBER_SINCE: 'Member Since',
  REWARD_POINTS: 'Reward Points',
  EXPIRY: 'expiry - ',
  SPENT: 'Spent ₹',
  VIEW_HISTORY: 'View History',
  ENJOY_BENEFITS: 'ENJOY EXCLUSIVE BENEFITS WITH',
  FLX_MEMBERSHIP: 'FLX Membership',
  FLX_REWARDS_DASHBOARD: 'FLX Rewards Dashboards',
  FLX_REWARDS_DASBOARD_NO_DATA: 'Join FLX for free! Know More.',
};

export const RIGHT_ARROW_ICON_SIZE = '24px';
